import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import SingleSelectModal from "../modals/SingleSelectModal";
import ToolbarButton, { ToolbarButtonProps } from "../ToolbarButton";

export interface SelectModeButtonProps extends ToolbarButtonProps {
  onPositionUpdate?: (rect: DOMRect) => void;
}

const SelectModeButton = forwardRef<HTMLButtonElement, SelectModeButtonProps>(
  ({ tooltip, icon, sizes, onPositionUpdate, ...rest }, ref) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    // Combine refs
    useImperativeHandle(ref, () => buttonRef.current!);

    // Update position when modal opens
    React.useEffect(() => {
      if (isModalOpen && buttonRef.current && onPositionUpdate) {
        const rect = buttonRef.current.getBoundingClientRect();
        onPositionUpdate(rect);
      }
    }, [isModalOpen, onPositionUpdate]);

    const handleClick = () => {
      setModalOpen(!isModalOpen);
    };

    return (
      <>
        <ToolbarButton
          {...rest}
          ref={buttonRef}
          tooltip={tooltip}
          icon={icon}
          onClick={handleClick}
          sizes={sizes}
        />
        <SingleSelectModal 
          open={isModalOpen} 
          onClose={() => setModalOpen(false)} 
          sizes={sizes}
          buttonPosition={buttonRef.current?.getBoundingClientRect()}
        />
      </>
    );
  }
);

export default SelectModeButton;